/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
import Object from "sap/ui/base/Object";

/**
 * @namespace sap.esh.search.ui.controls.resultview
 */
export default class SearchResultListSelectionHandler extends Object {
    isMultiSelectionAvailable(): boolean {
        return false;
    }
}
